import { useEffect } from "react";
import { useUserStore } from "./useUserStore";
import { useAuthStore } from "./useAuthStore";
import { observer } from "mobx-react-lite";

/**
 * Hook for retrieving and working with the user profile from UserStore.
 * This hook now uses MST stores instead of direct Supabase queries.
 * Components using this hook should be wrapped with `observer` from mobx-react-lite.
 */
export function useProfile() {
  const authStore = useAuthStore();
  const userStore = useUserStore();

  useEffect(() => {
    // Load profile when auth is ready and we don't have profile yet
    if (authStore.userId && !userStore.userProfile && !userStore.isLoading) {
      userStore.loadProfile(authStore.userId);
    }
  }, [authStore.userId, userStore.userProfile, userStore.isLoading, userStore]);

  // Return in a format compatible with existing usage
  return {
    data: userStore.userProfile,
    isLoading: userStore.isLoading,
    error: userStore.error,
    refetch: () => {
      if (authStore.userId) {
        return userStore.loadProfile(authStore.userId);
      }
      return Promise.resolve(null);
    },
  };
}
